<div class="app-modal-title">
	<div>Layers</div>
</div>

<div class="app-modal-content">
	<div class="check-all">
		<div class="layer-checkbox">
			<input type="checkbox" name="check-all" [(ngModel)]="isCheckAll" (ngModelChange)="onTggleCheckAll()">
		</div>
		<div class="">All</div>
	</div>
	<div class="layer-list">
		<div *ngFor="let layer of layers; let idx = index;" class="layer-item">
			<div class="layer-checkbox">
				<input type="checkbox" name="layer-{{idx}}" [(ngModel)]="layer.isSelected">
			</div>
			<div class="layer-name" (click)="layer.isSelected=!layer.isSelected">{{layer.name}}</div>
		</div>
	</div>
</div>
<div class="app-modal-footer">
	<div class="schema-menu">
		<label>Schema</label>
		<select name="schema" [(ngModel)]="selectedSchema">
			<option *ngFor="let schema of schemaDefinedByList" [ngValue]="schema">{{schema.name}}</option>
		</select>
	</div>
	<div class="button-menu">
		<button class="button-general" md-raised-button [disabled]="checkDisableDownload()" (click)="download()">Download</button>
	</div>
</div>